import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from './logpdf.js';
import __var_2__ from './factory.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Natural logarithm of the probability density function (PDF) for a chi distribution.
*
* @module @stdlib/stats/base/dists/chi/logpdf
*
* @example
* var logpdf = require( '@stdlib/stats/base/dists/chi/logpdf' );
*
* var y = logpdf( 2.0, 1.0 );
* // returns ~-2.226
*
* @example
* var factory = require( '@stdlib/stats/base/dists/chi/logpdf' ).factory;
*
* var logpdf = factory( 6.0 );
*
* var y = logpdf( 3.0 );
* // returns ~-1.088
*/

// MODULES //
var setReadOnly = __var_0__;
var logpdf = __var_1__;
var factory = __var_2__;


// MAIN //

setReadOnly( logpdf, 'factory', factory );


// EXPORTS //
export default logpdf;
